import { render } from "./CreateClientModal.vue?vue&type=template&id=13a6bbee&scoped=true"
import script from "./CreateClientModal.vue?vue&type=script&lang=js"
export * from "./CreateClientModal.vue?vue&type=script&lang=js"

import "./CreateClientModal.vue?vue&type=style&index=0&id=13a6bbee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a6bbee"]])

export default __exports__